export default "__VITE_ASSET__CcFT15IX__"